var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.user.avatar
    ? _c(
        "div",
        { staticClass: "rounded-circle d-flex", style: `${_vm.sizeComputed}` },
        [
          _c("img", {
            staticClass: "img-fluid rounded-circle",
            attrs: { src: _vm.avatarUrl, alt: "" },
          }),
        ]
      )
    : _c(
        "div",
        {
          staticClass:
            "rounded-circle d-flex justify-content-center align-items-center",
          style: `${_vm.sizeComputed} background-color:${_vm.strToColor};`,
        },
        [
          _c("div", { staticClass: "text-white" }, [
            _vm._v("\n    " + _vm._s(_vm.initial) + "\n  "),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }